import { TsrctSupplierContactNamePolicy } from '@/generated/gql/graphql';

export type ContactNameHint = {
  severity: 'info' | 'warning';
  key: 'generic' | 'partial' | 'required';
  name?: string;
};

const present = (value: string | null | undefined): string | null => value?.trim() || null;

// Mirrors tesseract's applyNamePolicy: a greeting by name needs both names, except under
// USE_ANY_NAME where a single name is used as is. REQUIRE_FULL is enforced by the tesseract
// send-out gate, the UI only explains it (design decision 5).
export const resolveContactNameHint = (
  policy: TsrctSupplierContactNamePolicy | undefined,
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): ContactNameHint | null => {
  if (!policy) return null;

  const first = present(firstName);
  const last = present(lastName);
  if (first && last) return null;

  if (policy === TsrctSupplierContactNamePolicy.REQUIRE_FULL) {
    return { severity: 'warning', key: 'required' };
  }
  if (policy === TsrctSupplierContactNamePolicy.USE_ANY_NAME) {
    const name = first ?? last;
    if (name) return { severity: 'info', key: 'partial', name };
  }
  return { severity: 'info', key: 'generic' };
};
